import { render, staticRenderFns } from "./recordTable.vue?vue&type=template&id=0707def9&scoped=true"
import script from "./recordTable.vue?vue&type=script&lang=js"
export * from "./recordTable.vue?vue&type=script&lang=js"
import style0 from "./recordTable.vue?vue&type=style&index=0&id=0707def9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707def9",
  null
  
)

export default component.exports